import { formatReservationDate } from "@/lib/reservation-date";

/**
 * `date` è ISO (yyyy-mm-dd, dal date-picker nativo) — formattata in testo
 * leggibile solo al momento di comporre il messaggio, vedi formatReservationDate.
 * Ora e ospiti restano da tendina a opzioni fisse (fedeltà al prototipo approvato).
 */
export interface ReservationInput {
  name: string;
  date: string;
  time: string;
  guests: string;
  notes?: string;
}

type Locale = "it" | "en";

function sanitizeWhatsAppNumber(rawNumber: string): string {
  return rawNumber.replace(/[^0-9]/g, "");
}

export function buildReservationMessage(input: ReservationInput, locale: Locale): string {
  const name = input.name.trim() || "—";
  const notes = input.notes?.trim();
  const date = formatReservationDate(input.date, locale);

  const base =
    locale === "en"
      ? `Hello, I'd like to book a table for ${input.guests}, ${date} at ${input.time}. Under the name ${name}.`
      : `Buongiorno, vorrei prenotare un tavolo per ${input.guests}, ${date} alle ${input.time}. A nome ${name}.`;

  if (!notes) return base;
  return `${base} ${locale === "en" ? "Notes" : "Note"}: ${notes}.`;
}

export function buildReservationWhatsAppUrl(whatsappNumber: string, input: ReservationInput, locale: Locale): string {
  const number = sanitizeWhatsAppNumber(whatsappNumber);
  const message = buildReservationMessage(input, locale);
  return `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
}
